import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  closeMenu() {
    const navbar = document.querySelector('.navbar-collapse');
    if (navbar) {
      // Remove the 'show' class to collapse the navbar
      navbar.classList.remove('show');
    }
  }

  // Handles the search event from the search component.
  onSearch(query: string) {
    this.router.navigate(['/report'], { queryParams: { search: query } });
  }

}
